import { computed, observable, component } from 'knockout-decorators'

import { RegistrationStatus } from '@tixa/schema'
import { Analytics, ErrorReporter, Language } from '~/utils'
import { pageState } from '~/store/page'

import type { SignInOptions } from '../utils/options'

import source from './register.html?raw'
import { authState } from '../utils/state'
import { createPerson } from '../utils/create-person'
import { AnalyticsEventsHandler } from '~/utils/analytics/types'

@component('register-form', source)
export class RegisterForm {
  constructor(private options: SignInOptions) {
    if (options.mode === 'login') {
      this.wantsToRegister = true
    }
  }

  private state = authState

  @observable public email = authState.email
  @observable public password = ''
  @observable public password2 = ''

  @observable public wantsToRegister = false
  @observable public isUserExistsFeedbackVisible = false
  @observable public isWeakPassFeedbackVisible = false

  @observable public isLoading = false

  @computed get canRegister(): boolean {
    return (
      this.email.length > 0 &&
      this.password === this.password2 &&
      this.password.length > 7
    )
  }

  private Locale = Language.getInstance()

  public i18n(key: string): string {
    return this.Locale.translations[key]
  }

  private async registerAccount() {
    if (this.isLoading || this.state.isLoading) return
    this.isUserExistsFeedbackVisible = false
    this.isWeakPassFeedbackVisible = false

    if (!this.wantsToRegister && this.options.signedInAsGuest) {
      this.options.signedInAsGuest(this.email)
      return
    }

    this.state.isLoading = true
    this.isLoading = true

    try {
      const result = await pageState.api.authentication.register({
        email: this.email,
        password: this.password,
      })
      if (result.status === RegistrationStatus.success) {
        try {
          const user = await pageState.api.user.GetUser()
          if (user && typeof user === 'object') {
            this.state.user = await pageState.api.user.GetUser()
          } else {
            this.state.user = {
              person: createPerson(this.email),
            }
          }
        } catch {
          this.state.user = {
            person: createPerson(this.email),
          }
        } finally {
          this.options.signedIn(this.email)
        }
        const analyticsInstance: AnalyticsEventsHandler =
          Analytics.getInstance()
        if (analyticsInstance && analyticsInstance.registered) {
          analyticsInstance.registered(0, 'HUF')
        }
        this.options.signedIn(this.email)
      } else if (result.status === RegistrationStatus.emailExists) {
        this.isUserExistsFeedbackVisible = true
      } else if (result.status === RegistrationStatus.weakPass) {
        this.isWeakPassFeedbackVisible = true
      }
    } catch (error) {
      ErrorReporter.exception(error as Error)
    } finally {
      this.state.isLoading = false
      this.isLoading = false
    }
  }

  private gotoLogin() {
    if (this.isLoading || this.state.isLoading) return
    this.options.signIn()
  }
}
